<template>
  <div>
    <article class="site-container" :class="{ 'site-container-lg': large, 'site-container-xl': xl }">
      <slot />
    </article>
  </div>
</template>

<script>
export default {
  name: 'Container',
  props: {
    large: {
      type: Boolean,
      default: false
    },
    xl: {
      type: Boolean,
      default: false
    },
    smallGutters: {
      type: Boolean,
      default: false
    }
  }
}
</script>
